import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import httpService from '../../../services/httpService';
import { notify } from '../../../bmr/utils/methods/notification';

const initialState = {
    isLoading: false,
   AssignedTemplatesList:[],
   productDropdown:[],
   assignedSectionPermission:[],
    selectedRolesFormatted: []
};

// fetch the all email types 
export const fetchAllAssignedTemplates = createAsyncThunk(
    'bmr/fetchAllAssignedTemplates',
    async (params, { rejectWithValue }) => {
        try {
            const response = await httpService.get('/getAssignedTemplates', { params: params });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
//get product types to be used
export const fetchProductTypes = createAsyncThunk(
    'bmr/fetchProductTypes',
    async (_, { rejectWithValue }) => {
        try {
            const response = await httpService.get('/getProductTypes');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

//@info handle post of the assigned permission to template
export const assignedPermission = createAsyncThunk(
    'bmr/assignedPermission',
    async (args, { rejectWithValue }) => {
        try {
            const response = await httpService.post('/assignTemplatePermission', args);
            notify.success(response.message);
            return response.data;
        } catch (error) {
            notify.error(error || error.message);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);


//@info handle update permission status (toggle switch)
export const updatePermission = createAsyncThunk(
    'bmr/updateAssignTemplateStatus',
    async (args, { rejectWithValue }) => {
        try {
            const response = await httpService.post(`/updateAssignTemplateStatus/${args.id}`, { status: args.status });
            notify.success(response.message);
            return response.data;
        } catch (error) {
            notify.error(error || error.message);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// In FbAssignedPermission slice — saveSectionPermission
export const saveSectionPermission = createAsyncThunk(
    'bmr/saveSectionPermission',
    async (args, { rejectWithValue }) => {
        try {
            const response = await httpService.post(
                `/saveSectionPermission/${args.assignedId}`,
                { question_schema: args.question_schema }
            );
            notify.success(response?.message || "Permissions saved successfully");
            return response.data;
        } catch (error) {
            notify.error(error?.message || "Failed to save permissions");
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// fetch the assigned section permission
export const fetchAssignedPermission = createAsyncThunk(
    'bmr/getAssignFormById',
    async (args, { rejectWithValue }) => {
        try {
            const response = await httpService.get(`/getAssignFormById/${args.assignedId}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

//@info handle post of the assigned permission to template
export const updateAssignTemplatePermission = createAsyncThunk(
    'bmr/updateAssignTemplatePermission',
    async (args, { rejectWithValue }) => {
        try {
            const response = await httpService.post(`/updateAssignTemplatePermission/${args.id}`, args);
            notify.success(response.message);
            return response.data;
        } catch (error) {
            notify.error(error || error.message);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);


const assignedTemplatesSlice = createSlice({
    name: 'assignedTemplates',
    initialState,    reducers: {
        setSelectedRolesFormatted: (state, action) => {
            state.selectedRolesFormatted = action.payload },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllAssignedTemplates.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAllAssignedTemplates.fulfilled, (state, action) => {
                state.isLoading = false;
                state.AssignedTemplatesList = action.payload
            })
            .addCase(fetchAllAssignedTemplates.rejected, (state) => {
                state.isLoading = false;
            })
            //@info fetch product dropdown list
            .addCase(fetchProductTypes.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchProductTypes.fulfilled, (state, action) => {
                state.isLoading = false;
                state.productDropdown = action.payload
            })
            .addCase(fetchProductTypes.rejected, (state) => {
                state.isLoading = false;
            })
            //@info POST of assigne permission template
            .addCase(assignedPermission.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(assignedPermission.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(assignedPermission.rejected, (state) => {
                state.isLoading = false;
            })
            //@info update permission status (toggle switch)
            .addCase(updatePermission.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updatePermission.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(updatePermission.rejected, (state) => {
                state.isLoading = false;
            })

            //@info update permission status (toggle switch)
            .addCase(saveSectionPermission.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(saveSectionPermission.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(saveSectionPermission.rejected, (state) => {
                state.isLoading = false;
            })

            //@info fetch assigned permission of the section
             .addCase(fetchAssignedPermission.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAssignedPermission.fulfilled, (state, action) => {
                state.isLoading = false;
                state.assignedSectionPermission = action.payload
            })
            .addCase(fetchAssignedPermission.rejected, (state) => {
                state.isLoading = false;
            })    
                    
            //@info fetch updateAssignTemplatePermission permission of the section
             .addCase(updateAssignTemplatePermission.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateAssignTemplatePermission.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(updateAssignTemplatePermission.rejected, (state) => {
                state.isLoading = false;
            })            
        }
    
});

export const { setSelectedRolesFormatted } = assignedTemplatesSlice.actions;
export default assignedTemplatesSlice.reducer;
